export default "__VITE_ASSET__c3e7a86e__"